import React from 'react';
import styled from 'styled-components';

const SLogo = styled.img`
  border-radius: 50%;
  display: inline-block;
  object-fit: contain;
`;

export default SLogo;
